import React, { useState, useEffect } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, InputLabel, Select, MenuItem, TextField, Button, Tooltip } from "@mui/material"
import Alert from "@mui/material/Alert"
import Swal from "sweetalert2"
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import BackIcon from "../../../components/BackIcon"
import GrabarIcon from "../../../assets/iconos/Grabar.ico"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))
const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const CrearPasillo = () => {
  const navigate = useNavigate()

  // Valores por defectos para los comboboxes y el check
  const Estados = [
    { value: "A", description: "ACTIVO" },
    { value: "I", description: "INACTIVO" },
  ]
  // Estados para manejaar el formulario de opciones
  // cuando llame a las funciones set, se actualizara el valor de los otros campos y se re renderiza
  const [codigo, setCodigo] = useState("")
  const [descripcion, setDescripcion] = useState("")
  const [estadoPasillo, setEstadoPasillo] = useState(Estados[0])

  const { mutateAsync: createPasillo, isPending: isCreatingPasillo } = useCreatePasillo()

  function useCreatePasillo() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (pasillo) => {
        // send api update request here
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify(pasillo),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json", options.body)
        let response = await fetchwrapper(`/Pasillos/createPasillo`, options)

        response = response.json()
        console.log(response)
        return response
      },
      // client side optimistic update
      onMutate: (newPasillo) => {
        console.log(newPasillo, "onmutate")
        queryClient.setQueryData(["Pasillo", newPasillo.id], (prevPasillo) => ({
          ...newPasillo,
        }))
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const pasillo = {
        codigoPasillo: codigo,
        descripcionPasillo: descripcion,
        estadoPasillo: estadoPasillo.value,
      }
      await createPasillo(pasillo)
      Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: "Se pudo crear el pasillo",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/home/dashboard/Pasillos") // Navegar a la ruta especificada
        }
      })
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "No se pudo crear el pasillo",
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/home/dashboard/Pasillos") // Navega de vuelta cuando se cierre el SweetAlert
      })
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Pasillos</b>
        </div>
        <Box className={StyledRoot}>
          <form onSubmit={handleSubmit}>
            <Tooltip title="Grabar">
              <Button type="submit" color="primary" sx={{ marginTop: "15px" }}>
                <img src={GrabarIcon} alt="Grabar" style={{ width: "40px" }} />
              </Button>
            </Tooltip>
            <TextField
              label="Código"
              margin="normal"
              fullWidth
              value={codigo}
              required
              onChange={(e) => setCodigo(e.target.value)}
            />
            <TextField
              label="Descripción"
              margin="normal"
              fullWidth
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />
            <div>
              <InputLabel id="estadoPasillosCB" sx={{ paddingBlock: "15px", paddingLeft: "5px" }}>
                Estado del pasillo
              </InputLabel>
              <Select
                fullWidth
                disabled
                labelId="estadoPasillosCB"
                value={estadoPasillo.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const pasilloestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstadoPasillo(pasilloestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </form>
        </Box>
        <CustomBackdrop isLoading={isCreatingPasillo} />
      </div>
    </ThemeProvider>
  )
}

export default CrearPasillo
